export const QUERY_KEY_SINGLE_VOYAGE_PLANNED_RESOURCES = 'single_voyage_planned_resources'